// extracted by mini-css-extract-plugin
export default {"root":"MMuzrTmT2aTd2y7lI2BD","cart__item":"etpOgvEuMBQszBT4FUtF"};